import Swiper, { Navigation } from "swiper";
import ProtoScroll from "../modules/proto-scroll";
import ScrollMagic from "scrollmagic";

const blocks = {
  init() {
    ProtoScroll.init();
    this.examplePortfolio();
    this.events();
    this.protoSwiper();
    this.protoLaptopSwiper();
    this.activeClassScroll();
  },

  examplePortfolio() {
    const protoNav = $(".proto-nav");

    if (!protoNav.length) {
      return;
    }

  },

  events() {
    $(".proto-nav__item").on("click", (e) => {
      // Set active class for item
      $(".proto-nav__item").removeClass("active");
      $(e.currentTarget).addClass("active");

      // Change active proto preview
      const target = $(e.currentTarget).data("target");

      $(".proto").removeClass("active");
      $(`[data-id=${target}]`).addClass("active");
    });

    // Blocks stack active class toggle
    $(".blocks-stack__item").on("click", (e) => {
      const $target = $(e.currentTarget);
      if ($target.hasClass("active")) {
        $target.removeClass("active");
      } else {
        $target.addClass("active");
      }
    });

    // Page structure abstract active class toggle
    $(".layouts__button-item").on("click", (e) => {
      const $target = $(e.currentTarget);

      const isActive = $target.hasClass("active");

      // Remove active class from all buttons except the clicked one
      $(".layouts__button-item").not($target).removeClass("active");

      // Toggle active class on the clicked button
      if (!isActive) {
        $target.addClass("active");
      }

      const dataStructure = $target.data("structure");
      this.layoutSwitch(dataStructure);
      this.descSwitch(dataStructure);
    });

    // Page layout active class toggle
    $(".button-item").on("click", (e) => {
      const $target = $(e.currentTarget);

      const isActive = $target.hasClass("active");

      // Remove active class from all buttons except the clicked one
      $(".button-item").not($target).removeClass("active");

      // Toggle active class on the clicked button
      if (!isActive) {
        $target.addClass("active");
      }

      const dataStructure = $target.data("structure");
      this.structureSwitch(dataStructure);
    });

    //Element styling switch
    $(".editor__wysiwyg-button").on("click", (e) => {
      const target = $(e.currentTarget);
      const formating = target.data("option");
      const editTarget = $("#edit-target");
      const isActive = target.hasClass("active");

      $(".editor__wysiwyg-button").not(target).removeClass("active");
      if (!isActive) {
        target.addClass("active");
      }

      if (editTarget.attr('class') != undefined) {
        editTarget.removeClass();
      };
      $("#edit-target").addClass(formating);
      this.explanationSwitch(formating);
    })


    // Cards stack switch
    let animating = false;
    const stackButtons = $('.wywg-ecom__buttons').find('button');
    stackButtons.on('click', (e) => {
      if (animating) return;
      const btnEl = $(e.currentTarget);
      $("button").removeClass("active");
      btnEl.addClass("active");
      let object = {
        img: btnEl.data("img"),
        text: btnEl.data("text")
      };

      this.renderNext(object);

    });
  },

  renderNext(object) {
    let animating = true;

    // Add placeholder
    $(".wywg-ecom__pictures-stack").prepend(`<div class="card-item"></div>`);

    // Set data
    $(".card-item.next").html(`<img src="${object.img}">`);

    // start animation
    $(".wywg-ecom__img-desc").addClass("fade");
    $(".card-item.active").addClass("animate-out");
    $(".card-item.next").addClass("animate-in");

    $(".card-item.afternext").removeClass("afternext").addClass("next");

    $(".card-item").first().addClass("afternext");

    setTimeout(() => {
      $(".wywg-ecom__img-desc").text(object.text);
      $(".wywg-ecom__img-desc").removeClass("fade");

      $(".card-item.active").remove();
      $(".card-item.next.animate-in")
        .removeClass("next animate-in")
        .addClass("active");

      animating = false;
    }, 200);
  },

  layoutSwitch(dataStructure) {
    const $buttons = $(".page-wireframe");

    // Remove active class from all buttons
    $buttons.removeClass("active");

    // Find child elements with matching data-structure value and add active class
    $buttons.filter(function () {
      return $(this).data("structure") === dataStructure;
    }).addClass("active");
  },

  descSwitch(dataStructure) {
    const $desc = $(".ps-abstract__layout-description");

    // Remove active class from all buttons
    $desc.removeClass("active");

    // Find child elements with matching data-structure value and add active class
    $desc.filter(function () {
      return $(this).data("structure") === dataStructure;
    }).addClass("active");
  },

  structureSwitch(dataStructure) {
    const $buttons = $(".layout-option");

    // Remove active class from all buttons
    $buttons.removeClass("active");

    // Find child elements with matching data-structure value and add active class
    $buttons.filter(function () {
      return $(this).data("structure") === dataStructure;
    }).addClass("active");
  },

  explanationSwitch(formating) {
    const $expl = $(".editor__explanation-card");

    // Remove active class from all buttons
    $expl.removeClass("active");

    // Find child elements with matching data-structure value and add active class
    $expl.filter(function () {
      return $(this).data("expl") === formating;
    }).addClass("active");
  },

  activeClassScroll() {
    var controller = new ScrollMagic.Controller();
    var duration = 100;
    var delay = 70;

    // Loop through the list items and create a ScrollMagic scene for each.
    $('.process-block__steps li').each(function (index) {
      var listItem = $(this);
      var triggerElement = '#' + listItem.attr('id');


      new ScrollMagic.Scene({
        duration: duration,
        triggerElement: triggerElement,
        triggerHook: 0.9
      })
        .setClassToggle(triggerElement, 'active')
        .addTo(controller)
        .offset(delay * index);
    });
  },

  // pinContainer() {
  //   var controller = new ScrollMagic.Controller();

  //   new ScrollMagic.Scene({
  //     duration: 1000,
  //     triggerElement: '.process-block',
  //     triggerHook: 0.2
  //   })
  //     .setPin('.process-block__steps')
  //     .addTo(controller);
  // },

  protoSwiper() {
    // Mobile proto swiper
    const protoMobileEl = $(".proto--mobile");
    if (!protoMobileEl.length) {
      return;
    }

    if (protoMobileEl.length) {
      const navPrev = protoMobileEl.find(".swiper-button--prev");
      const navNext = protoMobileEl.find(".swiper-button--next");

      new Swiper(protoMobileEl.find(".swiper")[0], {
        spaceBetween: 50,
        breakpoints: {
          786: {
            slidesPerView: 2,
          },
          1100: {
            slidesPerView: 3,
          },
        },
        modules: [Navigation],
        navigation: {
          prevEl: navPrev[0],
          nextEl: navNext[0],
        },
      });
    }
  },

  protoLaptopSwiper() {
    const protoLaptopEl = $(".proto--laptop");
    if (!protoLaptopEl.length) {
      return;
    }
    const navPrev = protoLaptopEl.find(".swiper-button--prev");
    const navNext = protoLaptopEl.find(".swiper-button--next");

    new Swiper(protoLaptopEl.find(".swiper")[0], {
      slidesPerView: 1,
      modules: [Navigation],
      navigation: {
        prevEl: navPrev[0],
        nextEl: navNext[0],
      },
    });
  },

};

export default blocks;
